<span class="field-view-value" [style.backgroundColor]="backgroundColor">{{displayValue}}</span>
